import { style } from "@vanilla-extract/css";
import { vars } from "../../../styles";
import { buttonStyles } from "../../buttons/Button/Button.recipe";

export const saveButtonStyles = style([
  buttonStyles({ size: "medium", appearance: "filled", fullWidth: true }),
  {
    selectors: {
      "&[data-disabled]": {
        backgroundColor: `color-mix(in srgb, ${vars.colors.disabled}, ${vars.colors.white} 10%)`,
        cursor: "not-allowed",
        color: `color-mix(in srgb, ${vars.colors.onSurface}, ${vars.colors.surface} 50%)`,
      },
    },
  },
]);
